import React,{useState,useEffect} from 'react'
import ContactLanding from './ContactLanding/ContactLanding'
import {Container,Row,Col} from 'react-bootstrap'
import ContactAbout from './About/ContactAbout'
import Footer from '../Footer/Footer'
import { Button } from "react-bootstrap";
import { FaThumbsUp, FaThumbsDown } from "react-icons/fa";
export default function ContactUs() {
    const [isMobile, setIsMobile] = useState(false);
      const [feedback, setFeedback] = useState(null);
      const [submitted, setSubmitted] = useState(false);
      const handleFeedback = (type) => {
        setFeedback(type);
        setSubmitted(true);
      };
    
      useEffect(() => {
        const handleResize = () => {
          setIsMobile(window.innerWidth <= 768);
        };
        handleResize(); // initial check
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);
    
  return (
    <>
    <ContactLanding/>
    <ContactAbout/>
    <br></br><br></br><br></br>
    <div className="mt-4 p-3 border-top">
        {!submitted ? (
          <>
            <p className="mb-2 fw-bold" style={{textAlign:"center"}}>Was this information helpful?</p>
            <div className="d-flex gap-3 flex-wrap justify-content-center">
              <Button
                variant="outline-success"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("like")}>
                <FaThumbsUp /> Yes
              </Button>
              <Button
                variant="outline-danger"
                className="d-flex align-items-center gap-2"
                onClick={() => handleFeedback("dislike")}
              >
                <FaThumbsDown /> No
              </Button>
            </div>
          </>
        ) : (
          <p className="text-success mt-2" style={{textAlign:"center"}}>Thank you for your feedback! 🙏</p>
        )}
      </div>
      <br></br>
    <Footer/>
   
    </>
  )
}
 